var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart 1",
    clipPath: "url(#clip0_1946_3351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5009 1.50977C16.3749 1.52728 15.2734 1.84162 14.3077 2.42104C13.342 3.00045 12.5463 3.82443 12.0009 4.80977C11.4556 3.82443 10.6599 3.00045 9.69417 2.42104C8.72848 1.84162 7.62698 1.52728 6.50094 1.50977C4.70588 1.58776 3.01464 2.37302 1.79672 3.694C0.578794 5.01498 -0.0668157 6.76429 0.000934853 8.55977C0.000934853 15.3348 10.9569 23.1598 11.4229 23.4918L12.0009 23.9008L12.5789 23.4918C13.0449 23.1618 24.0009 15.3348 24.0009 8.55977C24.0687 6.76429 23.4231 5.01498 22.2052 3.694C20.9872 2.37302 19.296 1.58776 17.5009 1.50977Z",
    fill: "#7E8492"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1946_3351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.591797)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.809c3aca1adc01085ad1cbf4ea4775e1.svg";
export { ForwardRef as ReactComponent };